import type { utils } from 'blockly/core';

import { categoryCssConfig } from '../categoryCssConfig.js';
import { BEGINNER_SWITCH_COLOR } from './constants.js';

type ToolboxItemInfo = utils.toolbox.ToolboxItemInfo;

/** Beginner Switch category — button / switch sensing blocks. */
export function buildBeginnerSwitchCategory(): ToolboxItemInfo {
  return {
    kind: 'category',
    name: 'Switch',
    colour: String(BEGINNER_SWITCH_COLOR),
    cssconfig: categoryCssConfig('switch'),
    contents: [
      { kind: 'block', type: 'beginner_switch_when_pressed' },
      { kind: 'block', type: 'beginner_switch_when_released' },
      { kind: 'block', type: 'beginner_switch_is_pressed' },
      { kind: 'block', type: 'beginner_switch_is_released' },
      { kind: 'block', type: 'beginner_switch_wait_pressed' },
      { kind: 'block', type: 'beginner_switch_wait_released' },
    ],
  };
}
